var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliForm", {
    ref: "form",
    attrs: {
      title: `Edit ${_vm.isMembership ? "Membership" : "Pass"} Details`,
      textSubtitle: `Edit the price and/or tags for this ${
        _vm.isMembership ? "membership" : "pass"
      }.${
        _vm.isMembership
          ? " Pricing changes will be reflected in the next billing cycle."
          : ""
      }`,
      persistent: "",
      saveChanges: _vm.editing,
    },
    on: {
      submit: function ($event) {
        return _vm.submit()
      },
      reset: function ($event) {
        return _vm.$emit("reset")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "flex flex-col gap-4" },
              [
                _c("v-currency-field", {
                  ref: "inlinePriceText",
                  staticClass: "soli-round",
                  attrs: {
                    rules: [
                      (val) => !!val || "Price is required",
                      (val) =>
                        String(val).replace(/,/g, "") >= 0 ||
                        "Price must be greater than or equal to $0.00",
                      (val) =>
                        String(val).replace(/,/g, "") <= 500 ||
                        "Price must be not be greater than $500.00",
                    ],
                    outlined: "",
                    dense: "",
                    label: "Price",
                    "error-message": "errors.amount",
                    "prepend-inner-icon": "attach_money",
                    "validate-on-blur": "",
                    allowNegative: false,
                    "hide-details": "auto",
                  },
                  model: {
                    value: _vm.form.unit_amount,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "unit_amount", $$v)
                    },
                    expression: "form.unit_amount",
                  },
                }),
                _vm._v(" "),
                _vm.form.unit_amount === 0
                  ? _c("PriceCouponDuration", {
                      attrs: { disabled: !!_vm.purchaseOption.coupon_duration },
                      model: {
                        value: _vm.form.coupon_duration,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "coupon_duration", $$v)
                        },
                        expression: "form.coupon_duration",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.form.coupon_duration &&
                _vm.form.coupon_duration !== "forever"
                  ? _c("PriceCouponRestore", {
                      attrs: {
                        priceId: _vm.purchaseOption.price.id,
                        disabled: !!_vm.purchaseOption.coupon_duration,
                      },
                      model: {
                        value: _vm.form.restore_price_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "restore_price_id", $$v)
                        },
                        expression: "form.restore_price_id",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("PriceTags", {
                  ref: "priceTags",
                  model: {
                    value: _vm.form.tags,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "tags", $$v)
                    },
                    expression: "form.tags",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v
      },
      expression: "valid",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }